import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEnterprise } from '../../../contexts/EnterpriseContext';
import './index.css';
import './index.mobile.css';

function SectionTitle({ children }) {
  return (
    <div className="ffov-section-title">
      <span className="ffov-section-title-text">{children}</span>
      <span className="ffov-section-dot" />
    </div>
  );
}

export default function Overview() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enterprise, surveyProgress } = useEnterprise() || {};

  const STEPS = [
    { key: 'registration', label: t('ff.overview.step.registration'), status: 'done' },
    { key: 'materials', label: t('ff.overview.step.materials'), status: surveyProgress === 2 ? 'done' : 'active' },
    { key: 'review', label: t('ff.overview.step.review'), status: 'locked' },
    { key: 'publish', label: t('ff.overview.step.publish'), status: 'locked' },
  ];

  // const ANNOUNCEMENTS = [
  //   { date: '2026-06-15', text: '家庭友好企业评选正式启动报名' },
  //   { date: '2026-06-20', text: '评选规则与维度说明已发布' },
  //   { isPreview: true, text: '资料填写阶段将通过本页面公告通知，请保持邮箱畅通' },
  // ];

  const infoRows = enterprise
    ? [
        { label: t('ff.overview.info.companyName'), value: enterprise.companyName },
        { label: t('ff.overview.info.account'), value: enterprise.username, isCode: true },
        { label: t('ff.overview.info.email'), value: enterprise.email },
        { label: t('ff.overview.info.contact'), value: enterprise.nickname || enterprise.username },
      ]
    : [];

  const statusText = (status) => {
    if (status === 'done') return t('ff.overview.status.done');
    if (status === 'active') return t('ff.overview.status.active');
    return t('ff.overview.status.locked');
  };

  const noticeDeadline = (() => {
    const hardDeadline = new Date('2026-10-20');
    if (!enterprise?.activatedAt) return '10/20';
    const activated = new Date(enterprise.activatedAt);
    const computed = new Date(activated);
    computed.setDate(computed.getDate() + 21);
    const deadline = computed > hardDeadline ? hardDeadline : computed;
    const now = new Date();
    if (now > hardDeadline) return '10/20';
    return `${deadline.getMonth() + 1}/${deadline.getDate()}`;
  })();

  return (
    <div className="ffov-page">
      <h1 className="ffov-welcome">
        {t('ff.overview.welcome').replace('{name}', enterprise?.companyName || '')}
      </h1>
      <p className="ffov-subtitle">{t('ff.overview.subtitle')}</p>

      {/* 评选进度 */}
      <div className="ffov-card">
        <SectionTitle>{t('ff.overview.section.progress')}</SectionTitle>
        <div className="ffov-steps">
          {STEPS.map((step, i) => (
            <React.Fragment key={step.key}>
              <div className={`ffov-step ffov-step--${step.status}`}>
                <div className="ffov-step-pill-wrapper">
                  <div className="ffov-step-pill">
                    <span className="ffov-step-label">{step.label}</span>
                  </div>
                </div>
                <span className="ffov-step-status-text">{statusText(step.status)}</span>
              </div>
              {i < STEPS.length - 1 && (
                <div
                  className={`ffov-step-connector ${STEPS[i + 1].status !== 'locked' && step.status === 'done' ? 'ffov-step-connector--active' : ''}`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="ffov-notice-bar">
          <span className="ffov-notice-text">{t('ff.overview.notice', { deadline: noticeDeadline })}</span>
          <button
            className="ffov-notice-btn"
            onClick={() => navigate('/family-friendly/questionnaire')}
          >
            {t('ff.overview.btn.survey')}
          </button>
        </div>
      </div>

      {/* 企业报名信息 */}
      <div className="ffov-card">
        <div className="ffov-card-header">
          <SectionTitle>{t('ff.overview.section.companyInfo')}</SectionTitle>
          <button
            className="ffov-edit-btn"
            onClick={() => navigate('/family-friendly/company-info')}
          >
            {t('ff.overview.btn.edit')}
          </button>
        </div>
        <div className="ffov-info-table">
          {infoRows.map((row) => (
            <div key={row.label} className="ffov-info-row">
              <span className="ffov-info-label">{row.label}</span>
              {row.isCode ? (
                <span className="ffov-info-code">{row.value}</span>
              ) : (
                <span className="ffov-info-value">{row.value}</span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* 评选公告 */}
      {/* <div className="ffov-card">
        <SectionTitle>{t('ff.overview.section.announcements')}</SectionTitle>
        <div className="ffov-announcements">
          {ANNOUNCEMENTS.map((item, i) => (
            <div key={i} className="ffov-announcement-item">
              <span className="ffov-announcement-dot" />
              <span className="ffov-announcement-text">
                {item.isPreview ? (
                  <>
                    <strong>{t('ff.overview.announcement.preview')}</strong>
                    {' '}
                    {item.text}
                  </>
                ) : (
                  <>
                    <strong>{item.date}</strong>
                    {' '}
                    {item.text}
                  </>
                )}
              </span>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
}
